
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ReturnsManagementGrid extends Serenity.EntityGrid<ReturnsManagementRow, any> {
        protected getColumnsKey() { return 'ECommerce.ReturnsManagement'; }
        protected getDialogType() { return ReturnsManagementDialog; }
        protected getIdProperty() { return ReturnsManagementRow.idProperty; }
        protected getInsertPermission() { return ReturnsManagementRow.insertPermission; }
        protected getLocalTextPrefix() { return ReturnsManagementRow.localTextPrefix; }
        protected getService() { return ReturnsManagementService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.toolbar.findButton('add-button').hide();
        }
        protected getColumns() {

            var columns = super.getColumns();
            columns.push(
                {
                    field: 'Update',
                    name: 'Update',
                    format: ctx => '<button class="inline-action btn-success change-status">Update</button>',
                    width: 90,
                    minWidth: 90,
                    maxWidth: 90
                });

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();
                if (target.hasClass('change-status')) {
                    
                    var dialg = new ReturnsManagementDialog();
                    dialg.loadByIdAndOpenDialog(item.TransId, false);

                    dialg.element.on('dialogclose', () => {                      
                            this.refresh();                        
                    });                    
                }
                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }

    }
}